import { Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import { formatCurrency } from 'components/fomatter/currency/currency-formatter';
import { SeriesOfFundPortfolio } from 'model/fund';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useInvestorPortalBlockedIssuers from 'shared/hooks/use-investor-portal-blocked-issuers';
import { formatHiddenBalance } from 'shared/util/investor-portal-blocked-issuers-utils';

interface WalletSeriesRowProps {
    series: SeriesOfFundPortfolio;
    fundId: string;
    handleFundAndSeries: (series: SeriesOfFundPortfolio) => void;
    dataCy: string;
}

const WalletSeriesRow = (props: WalletSeriesRowProps) => {
    const { handleFundAndSeries, series, fundId, dataCy } = props;

    const { t } = useTranslation();
    const { isIssuerBlocked } = useInvestorPortalBlockedIssuers();

    const isBlockedByUnleash: boolean = isIssuerBlocked(fundId);

    const handleClick = () => {
        if (isBlockedByUnleash) {
            return;
        }

        handleFundAndSeries(series);
    };

    return (
        <div className="fund-container--child__fund-content--container">
            <div className="fund-container--child__fund-content--row">
                <Tooltip title={series.name}>
                    <div className="fund-container--child__fund-content--cell">{series.name}</div>
                </Tooltip>
                <div className="fund-container--child__fund-content--dashed">-------------------------------------------------------------------------</div>
                <div className="fund-container--child__fund-content--amount">
                    {formatHiddenBalance(isBlockedByUnleash, series.totalAmount, amount => formatCurrency(amount, 0, true))}
                </div>
            </div>
            <Tooltip title={isBlockedByUnleash ? t('wallet.modal.issuer-blocked-tooltip') : ''}>
                <span>
                    <div
                        onClick={handleClick}
                        className={clsx('wallet__items--button', isBlockedByUnleash && 'wallet__items--button-disabled')}
                        data-cy={dataCy}
                    >
                        {t('wallet.modal-button')}
                    </div>
                </span>
            </Tooltip>
        </div>
    );
};

export default WalletSeriesRow;
